import { getApi } from 'api';
import { AxiosResponse } from 'axios';
import { NoShowReasonFilter } from 'constants/NoShowReasonFilter';
import { PlanningKpiType } from 'constants/PlanningKpiType';
import { UserSourceFilter } from 'constants/UserSourceFilter';
import { IConfirmedKpiPeriod } from 'types/kpis/IConfirmedKpiPeriod';
import { INoShowKpiBucket } from 'types/kpis/INoShowKpiBucket';
import { IPlanningKpiBucket } from 'types/kpis/IPlanningKpiBucket';

export const getPlanningKpisRequest = async (props: { kpiType: PlanningKpiType }): Promise<IPlanningKpiBucket[]> => {
  const { kpiType } = props;
  const response: AxiosResponse<IPlanningKpiBucket[]> = await getApi().get(
    `agency-dashboard/planning-kpis?kpiType=${kpiType}`,
  );
  return response.data;
};

export const getNoShowKpiRequest = async (props: { reasonFilter: NoShowReasonFilter }): Promise<INoShowKpiBucket[]> => {
  const { reasonFilter } = props;
  const response: AxiosResponse<INoShowKpiBucket[]> = await getApi().get(
    `agency-dashboard/no-show-kpi?reasonFilter=${reasonFilter}`,
  );
  return response.data;
};

export const getConfirmedKpiRequest = async (props: {
  userSource: UserSourceFilter[];
}): Promise<IConfirmedKpiPeriod[]> => {
  const { userSource } = props;
  const query = userSource.map(s => `userSource=${s}`).join('&');
  const response: AxiosResponse<IConfirmedKpiPeriod[]> = await getApi().get(`agency-dashboard/confirmed-kpi?${query}`);
  return response.data;
};
